// extracted by mini-css-extract-plugin
module.exports = {"note":"TravelGuideNotes_note__TlZzu"};